const buttonTemplate = require('../templates/mobile/button.html');
const linkTemplate = require('../templates/mobile/link.html');
module.exports = {
    buttonTemplate,
    linkTemplate,
    lightboxTemplate: '',
};
